<template>
  <div class="main" id="Interests">
    <Header :From="'Profile'" id="Header" />
    <CContainer class="d-flex content-center min-vh-90" id="container">
      <div class="row p-0 m-0">
        <div class="col-lg-4 col-md-4 col-sm-12"></div>
        <div class="col-lg-12 col-md-12 col-sm-12 p-0 m-0 box account-box">
          <div class="title">
            <img src="/icons_2/prev.png" alt="" @click="$router.go(-1)" />
            <span> {{ $t("Interests.MyInterests") }} </span>
          </div>
          <div class="addresses">
            <div class="load" v-if="loading">
              <CIcon name="cil-cart" height="48" />
            </div>

            <div class="top">
              <b v-if="progress_bar.currentStep == 0"
                > {{ $t("Interests.Choose") }}</b
              >
              <b v-if="progress_bar.currentStep == 1"
                > {{ $t("Interests.Choosetypes") }}</b
              >
              <b v-if="progress_bar.currentStep == 2"
                >{{ $t("Interests.SelectedBrand") }}</b
              >
              <b v-if="progress_bar.currentStep == 3">{{ $t("Interests.Confirm") }}</b>

              <p>
                {{ $t("Interests.Recommend") }}
              </p>
            </div>

            <div class="progress-div">
              <!-- <step-progress
                :steps="progress_bar.mySteps"
                :current-step="progress_bar.currentStep"
                :icon-class="progress_bar.icon"
                active-color="#ef86c1"
                :active-thickness="2"
                :passive-thickness="2"
                :line-thickness="5"
              >
              </step-progress> -->
              <!-- <vue-step-progress-indicator
                :steps="progress_bar.mySteps"
                :active-step="progress_bar.currentStep"
                :show-label="false"
                :show-bridge="true"
                :styles="styleData"
              /> -->
              <vue-step :now-step="progress_bar.currentStep" :step-list="progress_bar.mySteps" active-color="#ef86c1"></vue-step>
            </div>
            <div
              class="swipe"
              id="swipe0"
              v-show="progress_bar.currentStep == 0"
            >
              <div class="swears">
                <div class="swear" @click="selectSwear('F')">
                  <img
                    src="/swear/womanswear.jpg"
                    alt=""
                    :style="
                      selected.swear == 'F' ? 'filter: brightness(90%);' : ''
                    "
                  />
                  <span>{{ $t("Interests.ShopW") }}</span>
                </div>
                <div class="swear" @click="selectSwear('M')">
                  <img
                    src="/swear/menswear.jpg"
                    alt=""
                    :style="
                      selected.swear == 'M' ? 'filter: brightness(90%);' : ''
                    "
                  />
                  <span>{{ $t("Interests.ShopM") }}</span>
                </div>
                <div class="swear" @click="selectSwear('A')">
                  <img
                    src="/swear/randomswear.jpg"
                    alt=""
                    :style="
                      selected.swear == 'A' ? 'filter: brightness(90%);' : ''
                    "
                  />
                  <span>{{ $t("Interests.ShopA") }}</span>
                </div>
              </div>

              <div class="bot row">
                <div class="col-6 left" @click="swipeNext()">
                  <a>{{ $t("Button.Pass") }}</a>
                </div>
                <div class="col-6 right">
                  <button
                    class="button-outlined"
                    v-if="selected.swear"
                    @click="swipeNext()"
                  >
                    {{ $t("Button.Continue") }}
                    <font-awesome-icon
                      class="faIcon"
                      icon="arrow-right"
                      style="float: right; margin-left: 5px; margin-top: 3px"
                    />
                  </button>
                  <button class="button-outlined button-gray" v-else>
                    {{ $t("Button.Continue") }}
                  </button>
                </div>
              </div>
            </div>
            <div
              class="swipe"
              id="swipe1"
              v-show="progress_bar.currentStep == 1"
            >
              <div class="styles row p-0 m-0">
                <div
                  class="style style-selected col-6 p-0 m-0"
                  v-for="style in styles"
                  :key="style.id"
                  @click="selectStyle(style.id, style.name)"
                >
                  <!-- Send name and id only §§§§§§§§§§§§§§§§§§§§§§§§§§§§§§§§§§§§§§§§§§§§§§§§§ -->
                  <img :src="style.logo" alt="" />
                  <img
                    class="heart"
                    src="/icons_2/heart.png"
                    alt=""
                    :style="
                      !selected.styles.includes(style.id) ? 'display:none;' : ''
                    "
                  />
                  <span>{{ style.name }}</span>
                </div>
              </div>
              <div class="bot row">
                <div class="col-6 left">
                  <a>{{ $t("Interests.SelectedStyles") }}: {{ selected.styles.length }}</a>
                </div>
                <div class="col-6 right">
                  <button
                    class="button-outlined"
                    v-if="selected.styles.length >= 3"
                    @click="swipeNext()"
                  >
                    {{ $t("Button.Continue") }}
                    <font-awesome-icon
                      class="faIcon"
                      icon="arrow-right"
                      style="float: right; margin-left: 5px; margin-top: 3px"
                    />
                  </button>
                  <button class="button-outlined button-gray" v-else>
                    {{ $t("Button.Continue") }}
                  </button>
                </div>
              </div>
            </div>

            <div
              class="swipe"
              id="swipe2"
              v-show="progress_bar.currentStep == 2"
            >
              <div class="styles row p-0 m-0">
                <div
                  class="col-4 style style-selected brand"
                  v-for="brand in brands"
                  :key="brand.id"
                  @click="selectBrand(brand.id, brand.name)"
                >
                  <img class="brand-img" :src="brand.logo" alt="" />
                  <img
                    class="heart"
                    src="/icons_2/heart.png"
                    alt=""
                    :style="
                      !selected.brands.includes(brand.id) ? 'display:none;' : ''
                    "
                  />
                </div>
              </div>
              <div class="bot row">
                <div class="col-6 left">
                  <a>{{ $t("Interests.SelectedBrand") }}: {{ selected.brands.length }}</a>
                </div>
                <div class="col-6 right">
                  <button
                    class="button-outlined"
                    v-if="selected.brands.length > 0"
                    @click="swipeNext()"
                  >
                    {{ $t("Button.Continue") }}
                    <font-awesome-icon
                      class="faIcon"
                      icon="arrow-right"
                      style="float: right; margin-left: 5px; margin-top: 3px"
                    />
                  </button>
                  <button class="button-outlined button-gray" v-else>
                    {{ $t("Button.Continue") }}
                  </button>
                </div>
              </div>
            </div>

            <div
              class="swipe"
              id="swipe2"
              v-show="progress_bar.currentStep == 3"
            >
              <div class="last results">
                <div class="result">
                  <p>
                    <b>{{ $t("Interests.Gender") }}:</b>
                    <span class="badge" v-if="selected.swear == 'F'"
                      >{{ $t("Shop.Women") }}</span
                    >
                    <span class="badge" v-else-if="selected.swear == 'M'"
                      >{{ $t("Shop.Men") }}</span
                    >
                    <span class="badge" v-else>{{ $t("Interests.All") }}</span>
                  </p>
                </div>
                <div class="result">
                  <p><b>{{ $t("Interests.Styles") }}:</b></p>
                  <div>
                    <span
                      class="badge"
                      v-for="style in selected.style_names"
                      :key="style"
                    >
                      {{ style }}
                    </span>
                  </div>
                </div>
                <div class="result">
                  <p><b>{{ $t("Interests.Brands") }}:</b></p>
                  <div>
                    <span
                      class="badge"
                      v-for="brand in selected.brand_names"
                      :key="brand"
                    >
                      {{ brand }}
                    </span>
                  </div>
                </div>
                <div class="row buttons">
                  <div class="col-6 full">
                    <font-awesome-icon
                      class="faIcon"
                      icon="times"
                      style="float: right;"
                      @click="cancelPopup()"
                    />
                  </div>
                  <div class="col-6 full">
                    <font-awesome-icon
                      class="faIcon"
                      icon="check"
                      style="float: left;"
                      @click="submitInterests()"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <vue-confirm-dialog></vue-confirm-dialog>
    </CContainer>
  </div>
</template>

<script>
import { userService } from "../../../_services";
import StepProgress from "vue-step-progress";
import VueStepProgressIndicator from "vue-step-progress-indicator";
import vueStep from 'vue-step'
import "vue-step-progress/dist/main.css";
import $ from "jquery";
import { typeService, brandService } from "../../../_services";
import Header from "../../../components/Header.vue";

export default {
  name: "Swiper",
  components: {
    "step-progress": StepProgress,
    VueStepProgressIndicator,
    vueStep,
    Header,
  },
  data: () => ({
    loading: false,
    user: {
      name: "",
      phone: "",
      email: "",
    },
    offset: 0,
    collapsePrefences: true,
    collapseAccount: false,

    progress_bar: {
      mySteps: ["", "", "", ""],
      currentStep: 0,
      icon: "fa fa-check",
    },
    selected: {
      swear: "",
      styles: [],
      brands: [],
      style_names: [],
      brand_names: [],
    },
    styles: [],
    brands: [],
    colors: [],
    styleData: {
    progress__wrapper: {
        display: "-ms-flexbox",
        display: "flex",
        flexWrap: "wrap",
        display: "flex",
        justifyContent: "flex-start",
        margin: "1rem 0",
    },
    progress__block: {
        display: "flex",
        alignItems: "center",
    },
    progress__bridge: {
        backgroundColor: "grey",
        height: "2px",
        flexGrow: "1",
        width: "20px",
    },
    progress__bubble: {
        margin: "0",
        padding: "0",
        lineHeight: "30px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "30px",
        width: "30px",
        borderRadius: "100%",
        backgroundColor: "transparent",
        border: "2px grey solid",
        textAlign: "center",
    },
    progress__label: {
        margin: "0 0.8rem",
    },
}
  }),
  created() {
    this.user = JSON.parse(localStorage.getItem("shop_user"));
  },
  methods: {
    swipeNext() {
      $("#swipe" + this.progress_bar.currentStep).slideUp(
        750,
        function() {
          this.progress_bar.currentStep++;
          $("#swipe" + this.progress_bar.currentStep).slideDown(500);
        }.bind(this)
      );
    },
    selectSwear(swear) {
      if (this.selected.swear != swear) {
        this.selected.swear = swear;
      } else {
        this.selected.swear = "";
      }
    },
    selectStyle(style_id, style_name) {
      if (this.selected.styles.indexOf(style_id) < 0) {
          this.selected.styles.push(style_id);
          this.selected.style_names.push(style_name);
      } else {
        this.selected.styles.splice(this.selected.styles.indexOf(style_id), 1);
        this.selected.style_names.splice(
          this.selected.style_names.indexOf(style_name),
          1
        );
      }
    },
    selectBrand(brand_id, brand_name) {
      if (this.selected.brands.indexOf(brand_id) < 0) {
        this.selected.brands.push(brand_id);
        this.selected.brand_names.push(brand_name);
      } else {
        this.selected.brands.splice(this.selected.brands.indexOf(brand_id), 1);
        this.selected.brand_names.splice(
          this.selected.brand_names.indexOf(brand_name),
          1
        );
      }
    },
    submitInterests() {
      let loader = this.$loading.show();
      userService
        .createDna(this.selected)
        .then(
          function(data) {
            console.log(data);
            this.$toast.success(
              this.$t("Interests.Update")
            );
            this.$router.push("/shop");
          }.bind(this)
        )
        .catch(
          function(ex) {
            this.$toast.error(
              this.$t("Toast.Fail")
            );
          }.bind(this)
        )
        .finally(function() {
          loader.hide();
        });
    },
    cancelPopup() {
      this.$confirm({
        title: `${this.$t("Interests.Cancel")}`,
        message:
          `${this.$t("Interests.YouSure")}?`,
        button: {
          no: `${this.$t("Button.Yes")}`,
          yes: `${this.$t("Button.No")}`,
        },
        /**
         * Callback Function
         * @param {Boolean} confirm
         */
        callback: (confirm) => {
          if (confirm) {
            this.$router.go(-1);
          }
        },
      });
    },
  },

  mounted() {
    let loader = this.$loading.show();
    userService.getDna().then(
      function(data) {
        console.log(data);
        this.selected.swear = data.dna.gender;
        this.selected.styles = data.dna.types_data.map((obj) => {
          return obj.id;
        });
        this.selected.style_names = data.dna.types_data.map((obj) => {
          return obj.name;
        });
        this.selected.brands = data.dna.brands_data.map((obj) => {
          return obj.id;
        });
        this.selected.brand_names = data.dna.brands_data.map((obj) => {
          return obj.name;
        });
      }.bind(this)
    );

    typeService.getAll().then(
      function(data) {
        console.log(data);
        this.styles = data.data;
      }.bind(this)
    );

    brandService
      .getAll()
      .then(
        function(data) {
          console.log(data);
          this.brands = data.data;
        }.bind(this)
      )
      .finally(function() {
        loader.hide();
      });
  },
};
</script>
<style lang="scss" scoped>
#Interests {
  .account-box {
    background: #fff;
    overflow: hidden !important;
  }
  .box {
    background: #fff;
    width: 100%;
    width: 50vw;
    margin-top: 70px !important;
    margin-left: 15px !important;
    box-shadow: 0 0 8px 1px #ddd;
    overflow-x: hidden !important;
    margin-bottom: 30px !important;
  }

  .title {
    letter-spacing: 2px;
    font-size: 20px;
    padding: 10px;
    border-bottom: 2px solid #ddd;
    color: #666;
  }
  .title img {
    float: left;
    width: 30px;
    margin-top: 5px;
  }
  .progress-div {
    padding: 10px 20px;
    margin-top: -30px;
    margin-bottom: 50px;
  }
  .top {
    padding: 10px 5px;
  }

  .swears {
    margin-top: -50px;
  }
  .swear {
    position: relative;
  }
  .swear img {
    width: 100%;
    padding: 5px 10px;
    filter: brightness(30%);
    height: 30vh;
    border-radius: 15px;
  }
  .swear span {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #fff;
    letter-spacing: 2px;
    font-weight: bold;
  }
  .bot .left {
    text-align: left;
    margin-top: 15px;
    font-size: 13px;
    margin-bottom: 20px;
    padding-left: 30px;
  }
  .button-gray {
    background: #888 !important;
    color: #fff !important;
    border: 1px solid #888;
    transition: 0.5s;
    cursor: not-allowed;
  }
  .button-gray:hover {
    background: #888 !important;
    color: #fff !important;
    border: 1px solid #888;
    transition: 0.5s;
  }
  .styles {
    padding: 5px 10px;
    position: relative;
    margin-top: -50px !important;
    width: 100%;
  }
  .style {
    padding: 5px 10px;
    position: relative;
    z-index: 99;
  }
  .style img {
    border-radius: 10px;
    width: 100%;
    height: 120px;
    padding: 5px;
    filter: brightness(60%);
    z-index: 99;
  }
  .style span {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 13px;
    letter-spacing: 1px;
    color: #fff;
  }
  .style .heart {
    position: absolute;
    width: 30px;
    height: 30px;
    top: 10px;
    left: 10px;
    z-index: 999999999999;
    filter: brightness(100%);
  }
  .brand .brand-img {
    height: 100% !important;
  }
  .results {
    margin-top: -50px;
    font-size: 13px;
  }
  .result p {
    display: inline-block;
  }
  .result div {
    display: inline-block;
  }
  .badge {
    background: #ef86c1;
    color: #fff;
    margin: 5px;
    padding-bottom: 4px;
  }
  .results .buttons {
    margin-bottom: 20px;
    text-align: center;
    position: relative;
  }
  .results .buttons .full {
    margin-top: 20px;
  }
  .results .buttons .full .faIcon {
    border: 2px solid #ef86c1;
    color: #ef86c1;
    width: 50px;
    height: 50px;
    padding: 10px;
    border-radius: 100px;
    transition: 0.5s;
  }
  .results .buttons .full .faIcon:hover {
    border: 2px solid #ef86c1;
    background: #ef86c1;
    color: #fff;
    width: 50px;
    height: 50px;
    padding: 10px;
    border-radius: 100px;
  }
  @media screen and (max-width: 720px) {
    .box {
      width: 100vw;
      max-width: 100vw;
      position: absolute;
      transform: translate(-50%);
      margin-top: 0px !important;
      box-shadow: 0 0 0 0 #ddd;
    }
    #Header {
      display: none;
    }
    .title {
      color: #ef86c1 !important;
    }
    .title img {
      display: inline-block;
    }
  }

  .step-progress__step span {
    font-size: 5px !important;
    display: none !important;
  }
  .step-progress__step:after {
    width: 35px;
    height: 35px;
  }
  .step-progress__step--active:after,
  .step-progress__step--valid:after {
    width: 25px;
    height: 25px;
  }
  .last {
    text-align: center;
  }
  .last img {
    width: 50%;
  }
}
</style>
